import { render } from "./ProjectsSection.vue?vue&type=template&id=18729461&scoped=true"
import script from "./ProjectsSection.vue?vue&type=script&lang=js"
export * from "./ProjectsSection.vue?vue&type=script&lang=js"

import "./ProjectsSection.vue?vue&type=style&index=0&id=18729461&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Desktop\\PROJECTS\\portfolio\\v1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18729461"]])

export default __exports__